import { render, staticRenderFns } from "./lossRows.vue?vue&type=template&id=6ee61ec2&scoped=true"
import script from "./lossRows.vue?vue&type=script&lang=js"
export * from "./lossRows.vue?vue&type=script&lang=js"
import style0 from "./lossRows.vue?vue&type=style&index=0&id=6ee61ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee61ec2",
  null
  
)

export default component.exports